import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useMainCardStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {},
        btnContainer: {
            marginBottom: theme.spacing(3),
        },
        btn: {
            paddingTop: theme.spacing(0.8),
            paddingBottom: theme.spacing(0.8),
            minWidth: "110px",
            "&:first-child": {
                marginRight: theme.spacing(2),
            },
        },
        btnDark: {
            backgroundColor: theme.palette.grey[900],
            color: theme.palette.common.white,
        },
        cardContent: {
            maxHeight: "calc(100vh - 250px)",
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(3),
            paddingBottom: 0,
        },
        overviewPanel: {
            backgroundColor: theme.palette.common.white,
            marginLeft: theme.spacing(-3),
            marginRight: theme.spacing(-3),
            marginBottom: theme.spacing(-3),
        },
    })
);

export const overviewCardStyles = (theme: Theme) => ({
    card: {
        margin: "25px",
    },
    cardCommon: {
        marginTop: theme.spacing(3),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    cardContent: {
        padding: theme.spacing(3.75),
        paddingTop: theme.spacing(4),
        "&:last-child": {
            paddingBottom: theme.spacing(3.75),
        },
    },
    cardTitle: {
        marginBottom: theme.spacing(2.5),
    },
    cardSubTitle: {
        fontSize: theme.typography.h5.fontSize,
        marginBottom: theme.spacing(2.5),
        marginTop: theme.spacing(2),
    },
    cardContainer: {
        display: "flex",
        alignItems: "stretch",
        marginBottom: theme.spacing(1),
        justifyContent: "space-between",
    },
    cardAllocation: {
        flex: "1",
    },
    cardReport: {
        flex: "1",
    },
});
